import { Mesh, buildGridGeometry, VBOGeometry, PhongMaterial } from "@xeokit/xeokit-sdk";

const setupGrid = (viewer) => {
  const gridGeometry = new VBOGeometry(
    viewer.scene,
    buildGridGeometry({
      size: 5000, // Dimension of the grid on the X and Z axes
      divisions: 200, // Number of divisions on the X and Z axes
    })
  );

  const gridMaterial = new PhongMaterial(viewer.scene, {
    color: [0.9, 0.9, 0.9], // Light gray color
    emissive: [0.15, 0.15, 0.15], // Small emissive boost for visibility
    alpha: 0.8, // Slight transparency for fading effect
    shininess: 15, // Soft reflection to make it interactive
    specular: [0.4, 0.4, 0.4], // Add subtle highlights
  });


  const gridMesh = new Mesh(viewer.scene, {
    geometry: gridGeometry,
    material: gridMaterial,
  });

  return { gridGeometry, gridMesh };
};

export default setupGrid;